<template>
  <div class="main main-really-raised w-50 ml-auto mr-auto">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card card-signup no-shadow mt-0">
            <div
              class="card-header card-header-primary negative blue-grad w-50"
            >
              <h4 class="card-title">{{ $t("message.admin.index") }}</h4>
            </div>
            <div class="card-body px-3 py-5 text-center">
              <!-- <router-link :to="{name: 'admin-registrations'}" class="btn w-25 btn-default" >{{$t('message.admin.registrations')}}</router-link>
                            <br>
                            <router-link :to="{name: 'admin-users'}" class="btn w-25 btn-default" >{{$t('message.admin.users')}}</router-link>
                            <br>
                            <router-link :to="{name: 'admin-logs'}" class="btn w-25 btn-default" >{{$t('message.admin.logs')}}</router-link>
                            <br>
                            <router-link :to="{name: 'admin-operations'}" class="btn w-25 btn-default" >{{$t('message.admin.operations')}}</router-link>
							<br>
                            <router-link :to="{name: 'admin-toc-offers'}" class="btn w-25 btn-default" >{{$t('message.admin.toc-offers')}}</router-link>
							<br>
                            <router-link :to="{name: 'admin-sad-builder'}" class="btn w-25 btn-default" >Конструктор ГТД</router-link>
							<br>
							<router-link :to="{name: 'admin-ca-history'}" class="btn w-25 btn-default" >{{$t('message.admin.ca-history')}}</router-link>
							<br>
							<router-link :to="{name: 'admin-news'}" class="btn w-25 btn-default" >{{$t('message.admin.news')}}</router-link>
							<br>
							<router-link :to="{name: 'admin-service-prices'}" class="btn w-25 btn-default" >{{$t('message.admin.serviceprices')}}</router-link>
							<br>
							<router-link :to="{name: 'admin-operations-history'}" class="btn w-25 btn-default" >{{$t('message.account.operation_history')}}</router-link> -->

              <button
                class="btn btn-secondary"
                style=""
                @click.prevent="toggleContracts"
              >
                <span v-if="is_contracts">Выключить меню контрактов</span>
                <span v-else>Включить меню контрактов</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "admin-index",
  data() {
    return {
      is_contracts: false,
    };
  },
  mounted() {
    let status = localStorage.getItem("attis-contracts");
    if (null == status) status = "0";
    this.is_contracts = parseInt(status);
    if (!this.$store.state.auth) this.$router.push({ name: "sign-in" });
  },
  methods: {
    toggleContracts() {
      this.is_contracts = this.is_contracts == 0 ? 1 : 0;
      localStorage.setItem("attis-contracts", this.is_contracts);
      this.$root.$emit("contractMenuChanged");
    },
  },
};
</script>
